import { POS_ROUTE } from "../../../constants/constants"

export const SECURITY_GROUPS_ROUTE = POS_ROUTE + "/security/list-security-groups"


export const SECURITY_APPROVALS_ROUTE = POS_ROUTE + "/security/approvals-list"
export const SECURITY_ROLE_GROUPS_ROUTE = POS_ROUTE + "/security/role-groups"